import { resizeFilePromise } from 'app/libs/ImageUtil';

export const getParsedCode = (code) => parseInt(code, 10);
export const getMatchedCode = (idx) => idx.toString().padStart(3, 0);
export const getFileExtension = (path) => {
	const strIndex = path.lastIndexOf('.');
	return path.substring(strIndex + 1) || 'jpg';
};
export const getExtension = (fileName) => (fileName.lastIndexOf('.') < 1 ? null : fileName.split('.').slice(-1));

export const checkFileExtensionType = (fileList) => {
	const ary = Array.from(fileList);

	const isExistNotAllowedTypeFromName = ary.some((item) => {
		const typeAry = item.name.split('.');
		const itemType = typeAry[typeAry.length - 1].toUpperCase();
		return !(itemType.indexOf('JPEG') !== -1 || itemType.indexOf('JPG') !== -1);
	});

	const isExistNotAllowedType = ary.some((item) => {
		const itemType = item.type.toUpperCase();
		return !(itemType.indexOf('JPEG') !== -1 || itemType.indexOf('JPG') !== -1);
	});
	if (isExistNotAllowedType || isExistNotAllowedTypeFromName) {
		return false;
	}
	return true;
};

export const checkAspectRatio = (blobUrl) =>
	new Promise((resolve) => {
		if (!blobUrl) resolve(true);
		const sizeCheck = new Image();
		sizeCheck.src = blobUrl;
		sizeCheck.onload = () => {
			const w = sizeCheck.width;
			const h = sizeCheck.height;
			const ratio = h / w;
			if ((ratio < 0.751 && ratio > 0.749) || (ratio < 0.563 && ratio > 0.561)) {
				resolve(true);
			} else {
				resolve(false);
			}
		};
	});

const resizeInfo = {
	resizeHeight: 1650,
	resizeWidth: 2200,
	resample: 1,
	format: 'jpeg',
};

const getImgSize = (blobUrl) =>
	new Promise((resolve) => {
		const sizeCheck = new Image();
		sizeCheck.src = blobUrl;
		sizeCheck.onload = () => {
			resolve({ width: sizeCheck.width, height: sizeCheck.height });
		};
	});

export const checkImgResize = async (url) => {
	const ImgInfo = await getImgSize(url);
	if (ImgInfo.width <= resizeInfo.resizeWidth && ImgInfo.height <= resizeInfo.resizeHeight) {
		return true;
	}
	return false;
};

export const resizeImg = async (data) => {
	const url = typeof data === 'object' ? URL.createObjectURL(data) : data;
	const isValid = await checkImgResize(url);
	if (isValid) {
		return {
			resizedUrl: url,
		};
	}
	const resizedFile = await resizeFilePromise(data, 'blob', resizeInfo);
	const resizedUrl = URL.createObjectURL(resizedFile);
	return {
		resizedFile,
		resizedUrl,
	};
};
